/**
 * Gets a stringified error or if the stringified result is an empy string or empty object the default .toString() is used.
 * Created because JSON.stringify(error) will return {} for Error objects (https://stackoverflow.com/a/50738205/16998523).
 *
 * @param {unknown} error
 */
export function getErrorString(error: unknown): string {
	if (error instanceof Error && error.stack) {
		return error.stack;
	}

	const errorString = JSON.stringify(error);
	return errorString && errorString !== '{}' ? errorString : `${error as string}`;
}

/**
 * Takes an unknown value and coerces it into an error and finally returns the error message string
 */
export function getErrorMessage(thrownError: unknown) {
	return _toErrorWithMessage(thrownError).message;
}

function _toErrorWithMessage(thrownError: unknown): {message: string} {
	if (_isErrorWithMessage(thrownError)) {
		return thrownError;
	}

	try {
		return new Error(JSON.stringify(thrownError));
	} catch {
		return new Error(String(thrownError));
	}
}

function _isErrorWithMessage(thrownError: unknown): thrownError is {message: string} {
	return (
		typeof thrownError === 'object'
    && thrownError !== null
    && 'message' in thrownError
    && typeof thrownError.message === 'string'
	);
}

function _isErrorWithName(error: unknown): error is {name: string} {
	return typeof error === 'object' && error !== null && 'name' in error && typeof error.name === 'string';
}

export function getErrorName(error: unknown): string | null {
	if (_isErrorWithName(error)) {
		return error.name;
	}

	return null;
}
